import { render, staticRenderFns } from "./BackStageMenu.vue?vue&type=template&id=e8e56332&scoped=true"
import script from "./BackStageMenu.vue?vue&type=script&lang=js"
export * from "./BackStageMenu.vue?vue&type=script&lang=js"
import style0 from "./BackStageMenu.vue?vue&type=style&index=0&id=e8e56332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e56332",
  null
  
)

export default component.exports